var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoWetSignature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 8,
    fill: "#FCEBE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0338 18.7189C32.0338 20.668 43.9235 16.3799 43.9235 18.7189C43.9235 24.1764 19.1695 25.5408 19.1695 30.2188C19.1695 37.0407 56.7878 24.1764 56.7878 30.2188C56.7878 38.0153 18 34.8967 18 41.9136C18 48.3457 57.9573 34.8967 57.9573 41.9136C57.9573 48.1508 24.6271 46.7864 24.6271 53.6084C24.6271 57.8965 51.1353 49.5152 51.1353 53.6084",
    stroke: "#F78670",
    strokeWidth: 3.89827,
    strokeMiterlimit: 22.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWetSignature);
export default __webpack_public_path__ + "static/media/NoWetSignature.d1cc6ce508c928e11c1f62d95800d558.svg";
export { ForwardRef as ReactComponent };